import React from 'react';
import { ConstantPermissions } from 'contexts/useConstant';
import Provider from 'components/Tvendo/BusinessPartner/DataMaster/BusinessPartner/BusinessPartnerSharedFile';

export default function () {
  return (
    <Provider
      cardType="S"
      permissions={{
        store: ConstantPermissions.BASE_BUSINESS_PARTNERS_STORE,
        show: ConstantPermissions.BASE_BUSINESS_PARTNERS_SHOW
      }}
    />
  );
}
